import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '../Layout';
import { Link } from 'react-router-dom';
import { fetchMealPlanData, deleteMeal, startNewDay, addFavouriteNutritionPlan, clearMessage } from '../../../redux/slices/customer/mealPlanSlice';
import '../../../global.css';
import iconPlus from '../../../images/plus.svg';
import { calculateCalories, formatNumber, calculateTDEE, calculateNutritionGoals, calculateManualNutritionGoals } from '../../../utils';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import showAlert from '../../../components/common/showAlert';

const MealPlan = () => {
  const dispatch = useDispatch();
  const mealPlanData = useSelector((state) => state.mealPlan.data);
  const { user_first_name, user_details } = useSelector((state) => state.protect);
  const { successMessage, errorMessage } = useSelector((state) => state.mealPlan);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [title, setTitle] = useState('');

  useEffect(() => {
      dispatch(clearMessage());
  }, []); 
 
  useEffect(() => {
    if (successMessage && successMessage !='') {
      showAlert('success', successMessage);
      dispatch(clearMessage());
    }
    if (errorMessage && errorMessage !='') {
      showAlert('error', errorMessage);
      dispatch(clearMessage());
    }
  }, [successMessage, errorMessage]);


  useEffect(() => {
    localStorage.removeItem('login_as_admin');
  }, []);

  const [selectedMealId, setSelectedMealId] = useState(null);
  const [nutritionGoals, setnutritionGoals] = useState(0);

  const [totals, setTotals] = useState({
    protein: 0,
    carb: 0,
    fat: 0,
    calories: 0,
  });

  useEffect(() => {
    dispatch(fetchMealPlanData());
  }, []);

   useEffect(() => {
    if (user_details && user_details.hasOwnProperty('date_of_birth')) {
      var tdee = calculateTDEE(user_details);
      if (user_details["manual_macros"] == 0){
        var nutritionGoals1 = calculateNutritionGoals(tdee, user_details);
        setnutritionGoals(nutritionGoals1);
      } else {
        var nutritionGoals2 = calculateManualNutritionGoals(user_details);
        setnutritionGoals(nutritionGoals2);
      }
    }
  }, [user_details]);

  useEffect(() => {
    if (mealPlanData) {
      const newTotals = { protein: 0, carb: 0, fat: 0, calories: 0 };
      
      mealCategories.forEach((category) => {
        const meals = mealPlanData[`${category.toLowerCase()}_nutrition_plans`] || [];
        
        meals.forEach((meal) => {
          JSON.parse(meal.ingredients).forEach((ingredient) => {
           // newTotals.protein += parseFloat(isNaN(ingredient.protein) ? parseFloat(ingredient.protein_per_unit):ingredient.protein) * (ingredient.quantity??1);
           // newTotals.carb += parseFloat(isNaN(ingredient.carb) ? parseFloat(ingredient.carb_per_unit):ingredient.carb) * (ingredient.quantity??1);
           // newTotals.fat += parseFloat(isNaN(ingredient.fat) ? parseFloat(ingredient.fat_per_unit):ingredient.fat) * (ingredient.quantity??1);

            newTotals.protein += (parseFloat(ingredient.protein ?? ingredient.protein_per_unit) || 0) * (ingredient.quantity ?? 1);
newTotals.carb += (parseFloat(ingredient.carb ?? ingredient.carb_per_unit) || 0) * (ingredient.quantity ?? 1);
newTotals.fat += (parseFloat(ingredient.fat ?? ingredient.fat_per_unit) || 0) * (ingredient.quantity ?? 1);


            console.log('ingredient.quantity----'+ingredient.quantity);
            newTotals.calories += calculateCalories([ingredient]);
          });
        });
      });
 
      setTotals(newTotals);
    }
  }, [mealPlanData]);

  const openModal = () => { 
    setIsModalOpen(true); 
  }
  const closeModal = () => { setIsModalOpen(false); }

  const handleChangeTitle = (event) => {
    setTitle(event.target.value);
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    closeModal();
    dispatch(addFavouriteNutritionPlan({ title: title}));
    setTitle('');
  };

  const handleDeleteMeal = (mealId, meal, category = '') => {
    var meal =  mealPlanData[category.toLowerCase()+'_nutrition_plans'].filter((meal) => meal.id !== mealId);
    confirmAlert({
      title: 'Confirm Deletion',
      message: 'Are you sure you want to delete this meal from meal plan?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => dispatch(deleteMeal({mealId, meal, category}))
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });    
  };

  const toggleIngredients = (mealId) => {
    setSelectedMealId(selectedMealId === mealId ? null : mealId);
  };

  const mealCategories = ['Breakfast', 'Lunch', 'Dinner', 'Snacks'];

  const handleStartNewDay = () => {
    confirmAlert({
      title: 'Confirm New Day',
      message: 'Are you sure you want to start new day?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => dispatch(startNewDay())
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  }

  return (
    <Layout>
      <main className="main" id="hhh">
        <header>
          <div className="main-head flex pb-0">
            <h1 className="greet-user-text">Hello, {user_first_name}!</h1>
          </div>
          <div className="my-3 meal-plan-btns">
            <Link id="weight-check-in" onClick={() => openModal(true)} className="btn-save-meal" style={{ marginRight: '10px' }}>Save Meal Plan</Link>
          </div>
        </header>
        <div className="main-content flex justify-between"> 
          <div className="main-content_left dashboard-content-left">
            <div className="meals-container meals-added">
              {mealCategories.map((category, index) => {
                const meals = mealPlanData[`${category.toLowerCase()}_nutrition_plans`] || [];
                return (
                  <div className="card" key={index}> 
                    <header className="flex align-center justify-between">
                      <h3>{category}</h3>
                    </header>
                    <div className="meals flex flex-col gap-m py-0">
                      {meals.length > 0 ? (
                        meals.map((meal, idx) => (
                          <div key={idx}>
                            <div className="meal-item flex align-center justify-between py-3">
                              <div className="meal-info flex">
                                <div
                                  style={{
                                    width: '120px',
                                    height: '120px',
                                    borderRadius: '15px',
                                    backgroundSize: 'cover',
                                    backgroundImage: `url(${meal.meal_picture_full_url})`
                                  }}
                                ></div>
                                <div className="meal-item-left">
                                  <h6>
                                    {meal.meal_name} 
                                    <span 
                                      className="toggle-ingredients" 
                                      style={{ cursor: 'pointer' }}
                                      onClick={() => toggleIngredients(meal.id)}
                                    >
                                      (Ingredients)
                                    </span>
                                  </h6>
                                  <span>{calculateCalories(JSON.parse(meal.ingredients)).toFixed(0)} kcal</span>
                                </div>
                              </div>
                              <div className="meal-item-right flex align-center gap-xsm">
                                <Link to={`/customize-meal/${meal.id}`}>
                                  <i className="bi bi-pencil-square"></i>
                                </Link>
                                <i onClick={() => handleDeleteMeal(meal.id, meal, category.toLowerCase())} className="bi bi-trash3 cursor-pointer"></i>
                              </div>
                            </div>

                            {selectedMealId === meal.id && (
                              <div className="responsive-table-container" style={{ width: '100%' }}>
                                <table className="admin-table">
                                  <thead>
                                    <tr className="flex-between-center">
                                      <th style={{width:"100px"}}>Namess</th>
                                      <th>Quantity</th>
                                      <th>Unit</th>
                                      <th>Protein</th>
                                      <th>Carb</th>
                                      <th>Fat</th>
                                      <th>Calories</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {JSON.parse(meal.ingredients).map((ingredient, i) => (
                                      <tr key={i}>
                                        <td style={{width:"100px"}}>{ingredient.name || ingredient.ingredient_name}</td>
                                        <td>{ingredient.quantity || 1}</td>
                                        <td>{ingredient.unit}</td>

                                     <td>
                                     <span style={{whiteSpace: 'nowrap',display: 'inline-block'}}>
  {formatNumber(
    isNaN((ingredient.protein ?? ingredient.protein_per_unit) * (ingredient.quantity || 1))
      ? 0
      : (ingredient.protein ?? ingredient.protein_per_unit) * (ingredient.quantity || 1)
  )} g
  </span>
</td>

<td>
<span style={{whiteSpace: 'nowrap',display: 'inline-block'}}>
  {formatNumber(
    isNaN((ingredient.carb ?? ingredient.carb_per_unit) * (ingredient.quantity || 1))
      ? 0
      : (ingredient.carb ?? ingredient.carb_per_unit) * (ingredient.quantity || 1)
  )} g
  </span>
</td>

<td>
<span style={{whiteSpace: 'nowrap',display: 'inline-block'}}>
  {formatNumber(
    isNaN((ingredient.fat ?? ingredient.fat_per_unit) * (ingredient.quantity || 1))
      ? 0
      : (ingredient.fat ?? ingredient.fat_per_unit) * (ingredient.quantity || 1)
  )} g
  </span>
</td>

                                        <td>
                                        <span style={{whiteSpace: 'nowrap',display: 'inline-block'}}>
                                        {formatNumber(calculateCalories([ingredient], 'yes'))} kcal
                                        </span>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                  <tfoot>
                                    <td colspan="3">Total</td>
                                    <td>
                                    <span style={{whiteSpace: 'nowrap',display: 'inline-block'}}>
  {formatNumber(
    JSON.parse(meal.ingredients).reduce((total, ingredient) => {
  const protein = (parseFloat(ingredient.protein ?? ingredient.protein_per_unit) || 0) * (ingredient.quantity ?? 1);
  return total + protein;
}, 0)
  )} g
  </span>
</td>

<td>
<span style={{whiteSpace: 'nowrap',display: 'inline-block'}}>
  {formatNumber(
    JSON.parse(meal.ingredients).reduce((total, ingredient) => {
  const carb = (parseFloat(ingredient.carb ?? ingredient.carb_per_unit) || 0) * (ingredient.quantity ?? 1);
  return total + carb;
}, 0)
  )} g
  </span>
</td>
<td>
<span style={{whiteSpace: 'nowrap',display: 'inline-block'}}>
  {formatNumber(
    JSON.parse(meal.ingredients).reduce((total, ingredient) => {
  const fat = (parseFloat(ingredient.fat ?? ingredient.fat_per_unit) || 0) * (ingredient.quantity ?? 1);
  return total + fat;
}, 0)
  )} g
  </span>
</td>

                                    <td>
                                    <span style={{whiteSpace: 'nowrap',display: 'inline-block'}}>
                                      {
                                        String(formatNumber(
                                          JSON.parse(meal.ingredients)
                                            .reduce((total, ingredient) => total + calculateCalories([ingredient]), 0)
                                        ).replace(/^0+/, '')) || '0'
                                      } kcal
                                      </span>
                                    </td>
                                  </tfoot>
                                </table>
                              </div>
                            )}
                          </div>
                        ))
                      ) : (
                        <div className="meal-item flex align-center justify-between py-3">
                          <span>No meals added yet</span>
                        </div>
                      )}
                    </div>
                    <footer className="flex align-center gap-sm">
                      <Link to={`/add-meal/${category}`} className="add-meal-btn flex align-center gap-sm">
                        <span className="add-meal-btn-img flex align-center justify-center">
                          <img src={iconPlus} alt="+" />
                        </span>
                        <h6>Add Meal</h6>
                      </Link>
                    </footer>
                  </div>
                );
              })}
            </div>
          </div>

          <div id="content-right" className="main-content_right dashboard-content-right">
            <div className="dashboard-right-wrap">
              <section>
                <div className="card-red">
                  <div className="figure flex flex-col align-center justify-center border-0">
                    <h3 className="text-uppercase">{totals.calories && formatNumber(totals.calories) || '0'} kcal</h3>
                  </div>
                  <div className="goal flex align-center justify-between">
                    <p className="text-white text-uppercase">Goal</p>
                    <p className="text-white text-uppercase">{nutritionGoals && nutritionGoals['adjustedTDEE']} kcal</p>
                  </div>
                </div>
              </section>

              {totals && mealPlanData?.nutritionGoals && (
                ['protein', 'carb', 'fat'].map((macro, index) => (
                  <section key={index}>
                    <div className="carbs-div">
                      <p>{macro.charAt(0).toUpperCase() + macro.slice(1)}</p>
                      <h3> 
                        {isNaN(totals[macro]) ? 0 : formatNumber(totals[macro]) || 0} g
                        <span className="macro-of">
                          / {isNaN(mealPlanData?.nutritionGoals[macro]) ? 0 : formatNumber(mealPlanData?.nutritionGoals[macro]) || 0} g
                        </span>
                      </h3>
                    </div>
                  </section>
                ))
              )}

            </div>
            <div>
              <div className="form-group">
                <button onClick={handleStartNewDay} className="btn-curve">Start a new day</button>
              </div>
              <div className="form-group">
                <Link to="/favourite-meal-plans" className="btn-curve btn-green">
                  Favourite Meal Plans
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>



{isModalOpen && (
  <div
    className="modal fade show d-block"
    id="steps-check-in-modal"
    tabIndex="-1"
    aria-labelledby="stepsCheckInLabel"
    aria-hidden="true"
    style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
  >
    <div className="modal-dialog modal-dialog-centered modal-lg">
      <div className="modal-content">
        <div className="modal-header justify-content-center">
          <h5 className="modal-title" id="stepsCheckInLabel">
           Save Current Meal Plan
          </h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeModal}
          />
        </div>
        <div className="modal-body px-md-5 pb-md-4">

        <form onSubmit={handleFormSubmit}>
            <div className="row g-3 gx-md-5 gy-md-4">              
              <div className="col-md-12">
                <input
                  name="title"
                  type="text"
                  required
                  placeholder="Enter Meal Plan Name"
                  className="form-control"
                  value={title}
                  onChange={handleChangeTitle}
                />
              </div>
            </div>
            <div className="d-flex justify-content-center mt-md-4">
              <button type="submit" className="btn-curve">
                Submit
              </button>
            </div>
            </form>
        </div>
      </div>
    </div>
  </div>
)}


    </Layout>
  );
};

export default MealPlan;